<template>
  <v-container fluid>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>

    <v-row justify="space-between">
      <v-card-title> </v-card-title>

      <v-col cols="7">
        <v-text-field
          v-model="searchLocal"
          label="Buscar"
          prepend-icon="mdi-magnify"
          style="padding-right: 10px"
          hint="Buscar por: 'De', 'Para' o 'Asunto'."
          @change="buscarItems"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-card-actions>
      <v-btn small color="blue-grey" dark @click="$emit('agregarDepara')"
        >Nuevo de/para</v-btn
      >
    </v-card-actions>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th></th>
            <th
              v-for="(header, index) in headers"
              :key="`header-${index}`"
              class="text-left"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
        <!-- Aqui -->

        <tbody>
          <tr v-for="item in items" :key="item.name">
            <!-- Se puede agregar el campo relacionado -->
            <td></td>
            <td>{{ item.captura.titulo }} {{ item.captura.nombreCompleto }}</td>
            <td>{{ formatoFecha(item.fecha) }}</td>
            <td>{{ item.de }}</td>
            <td>{{ item.para }}</td>
            <td>{{ item.asunto }}</td>
            <td class="text-left">
              <router-link :to="`/depara/${item._id}`" class="link"
                ><v-btn icon
                  ><v-icon center>mdi-file-document</v-icon></v-btn
                ></router-link>
            </td>
            <!-- Boton para agregar documento -->
          </tr>
        </tbody>

        <!-- Editar esta parte -->
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <v-row no-gutters>
      <v-col cols="12">
        <v-toolbar dense flat>
          <v-spacer></v-spacer>
          <span class="text-caption"> Página: </span>
          <v-select
            v-model="paginaLocal"
            :items="paginasSelect"
            dense
            class="pagina-select"
            :disabled="loading"
            @change="changePage"
          />
          <span class="text-caption"
            >{{ rangoRegistros }} / {{ totalRegistros }}</span
          >
          <v-btn
            icon
            color="primary"
            :disabled="disablePrev || loading"
            @click="previousPage()"
            ><v-icon>mdi-chevron-left</v-icon></v-btn
          >
          <v-btn
            icon
            color="primary"
            :disabled="disableNext || loading"
            @click="nextPage()"
            ><v-icon>mdi-chevron-right</v-icon></v-btn
          >
        </v-toolbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {DateTime} from 'luxon';

export default {
  name: "simpleTable",
  props: [
    "headers",
    "items",
    "pagina",
    "paginas",
    "registrosPagina",
    "totalRegistros",
    "loading",
    "search",
  ],
  components: {},
  computed: {
    paginasSelect() {
      const paginas = [];
      for (let i = 1; i <= this.paginas; i++) paginas.push(i);
      return paginas;
    },
    rangoRegistros() {
      let inicio =
        this.paginaLocal * this.registrosPagina - this.registrosPagina + 1;
      let fin = inicio + this.items.length - 1;
      return `${inicio}-${fin}`;
    },
    disablePrev() {
      return this.paginaLocal <= 1;
    },
    disableNext() {
      return this.paginaLocal >= this.paginas;
    },
  },
  watch: {
    pagina(value) {
      this.paginaLocal = parseInt(value);
    },
    search(value) {
      this.searchLocal = value;
    },
  },
  data: () => ({
    show: false,
    paginaLocal: 1,
    searchLocal: "",
    menuItems: [
      { text: "Modificar depara", action: "modificarDepara" },
      { text: "Eliminar depara", action: "eliminarDepara" },
      { text: "Ver historial", action: "verHistorial" },
    ],
  }),
  mounted() {
    this.paginaLocal = parseInt(this.pagina);
    this.searchLocal = this.search;
  },
  methods: {
    formatoFecha(fecha){
        return fecha ? DateTime.fromSQL(fecha.split('T')[0]).toFormat('dd/MM/yyyy') : '';
      },
    changePage() {
      this.$emit("changePage", this.paginaLocal);
    },
    previousPage() {
      this.paginaLocal--;
      this.$emit("changePage", this.paginaLocal);
    },
    nextPage() {
      this.paginaLocal++;
      this.$emit("changePage", this.paginaLocal);
    },
    buscarItems() {
      this.$emit("searchItem", this.searchLocal);
    },
    menuAction(action, id) {
      this.$emit(action, id);
    },
  },
};

// Icono de file
// mdi-file-document
// mdi-file-outline
</script>

<style>
.pagina-select {
  max-width: 50px !important;
  margin-left: 15px;
  margin-right: 15px;
  padding-top: 15px !important;
}
</style>